var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable max-lines */
import { DrawerBody } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { DateTime } from 'luxon';
import React, { useEffect, useState, } from 'react';
import { getQuantityByStatus } from '../../../utils/order-details/LineItemUtils';
import { SubmitDeliveryAddressGetCitiesByZipCode } from '../../../api/oms/edit-delivery-address';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { OmmAvailableDeliverySlots, OmmAvailableFulfillmentOptions, } from '../../../hooks/delivery-hooks';
import { useExperienceContext, useOrderContext, useFulfillmentGroupContext, useEditDeliveryAddressContext, } from '../../../hooks/useContexts';
import { EditDeliveryAddressErrorMessages, } from '../../../models/edit-delivery-address';
import '../../../styles/drawer.scss';
import { getAddresses, submitEditDeliveryAddress, validateDeliveryAddress, getInitialZipCode, getIsZipCodeEligibilityEnabled, handleEligibility, } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { getWindow } from '../../../utils/general';
import { areAddressesEqual, extractAddressFromFulfillmentGroup, } from '../../../utils/order-details/OrderDetailsUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { getFlowTypeValue } from '../util/OutOfStock';
import { EditDeliveryAddressChangeFormBody } from './EditDeliveryAddressChangeFormBody';
import { EditDeliveryAddressChangeFormFooter } from './EditDeliveryAddressChangeFormFooter';
import { EditDeliveryAddressChooseAddress } from './EditDeliveryAddressChooseAddress';
export var EditDeliveryAddressChangeForm = function (_a) {
    var _b, _c, _d;
    var closeDrawer = _a.closeDrawer, setIsChangeForm = _a.setIsChangeForm, setIsDeliveryDetails = _a.setIsDeliveryDetails, setUpdatedAddressData = _a.setUpdatedAddressData, setNewDeliveryAddressDetails = _a.setNewDeliveryAddressDetails, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, previousCountry = _a.previousCountry, setIsAddressList = _a.setIsAddressList, isAddressList = _a.isAddressList, isDefaultValue = _a.isDefaultValue, setIsDefault = _a.setIsDefault, isLoading = _a.isLoading, setIsLoading = _a.setIsLoading, isExcludedAddress = _a.isExcludedAddress, setIsExcludedAddress = _a.setIsExcludedAddress, isValidated = _a.isValidated, setIsValidated = _a.setIsValidated, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, submitCreateForm = _a.submitCreateForm, setSubmitCreateForm = _a.setSubmitCreateForm, validationEt = _a.validationEt, setValidationEt = _a.setValidationEt, setIsDeliveryOptions = _a.setIsDeliveryOptions;
    var _e = useFulfillmentGroupContext(), fulfillmentGroup = _e.fulfillmentGroup, fulfillmentGroupIndex = _e.fulfillmentGroupIndex;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _f = useOrderContext(), orderDetailsData = _f.orderDetailsData, setShowDrawerError = _f.setShowDrawerError;
    var _g = useEditDeliveryAddressContext(), _h = _g.formState, firstNameValue = _h.firstNameValue, lastNameValue = _h.lastNameValue, streetAddressValue = _h.streetAddressValue, addressLineTwoValue = _h.addressLineTwoValue, zipCodeValue = _h.zipCodeValue, cityStateValue = _h.cityStateValue, phoneNumberValue = _h.phoneNumberValue, updateFormField = _g.updateFormField, setAvailableDeliverySlots = _g.setAvailableDeliverySlots, setSelectedDateId = _g.setSelectedDateId, setAvailableDeliverySlotsResponse = _g.setAvailableDeliverySlotsResponse, setDeliveryAddresses = _g.setDeliveryAddresses, setSelectedAddressId = _g.setSelectedAddressId, isEligibilityChecked = _g.isEligibilityChecked, isEligible = _g.isEligible, setIsEligible = _g.setIsEligible, setIsEligibilityChecked = _g.setIsEligibilityChecked;
    var _j = useOrderContext(), setFulfillmentOptionsResponse = _j.setFulfillmentOptionsResponse, setExcludedShipStateApiError = _j.setExcludedShipStateApiError, setDeliveryAddressesApiError = _j.setDeliveryAddressesApiError, setDeliveryAvailableSlotsApiError = _j.setDeliveryAvailableSlotsApiError, currentBopisOosDrawer = _j.currentBopisOosDrawer;
    var _k = useState(false), invalidField = _k[0], setInvalidField = _k[1];
    var _l = useState(previousCountry), country = _l[0], setCountry = _l[1];
    var _m = useState(false), isPOBoxAddressLine1 = _m[0], setIsPOBoxAddressLine1 = _m[1];
    var _o = useState(false), isPOBoxAddressLine2 = _o[0], setIsPOBoxAddressLine2 = _o[1];
    var _p = useState(false), isZipCodeChanged = _p[0], setIsZipCodeChanged = _p[1];
    var _q = useState([]), getCitiesByZipCode = _q[0], setGetCitiesByZipCode = _q[1];
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var traceId = orderDetailsData.traceId;
    var flowType = getFlowTypeValue(currentBopisOosDrawer, FLOW_TYPES.EDIT_DELIVERY_ADDRESS);
    var _r = useState(false), isSameAddress = _r[0], setIsSameAddress = _r[1];
    var _s = useThdCustomer() || {}, isLoggedIn = _s.isLoggedIn, isExchangeCustomer = _s.isExchangeCustomer;
    var _t = useState([]), localCities = _t[0], setLocalCities = _t[1];
    var _u = useState(false), enteredEditFlow = _u[0], setEnteredEditFlow = _u[1];
    var isAuthTHDUser = Boolean(isLoggedIn && !isExchangeCustomer);
    var isAddingNewAddress = Boolean(FeatureSwitches.enableEditDeliveryAddressAppify) && !isAddressList;
    var fulfillmentTypeCode = ((_c = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || undefined;
    var isZipCodeEligibilityEnabled = getIsZipCodeEligibilityEnabled(fulfillmentGroup);
    var _v = useState(false), isSkeletonLoading = _v[0], setIsSkeletonLoading = _v[1];
    // When switching back to the address list view, clear selection so the first tile is auto-selected
    useEffect(function () {
        if (isAddressList) {
            setSelectedAddressId('');
        }
    }, [isAddressList]);
    var handleZipCodeStatus = function () {
        if ((invalidField && zipCodeValue.length !== 5) || isExcludedAddress) {
            return 'error';
        }
        if (!isValidated) {
            return 'warning';
        }
        if (isSameAddress) {
            return 'error';
        }
        if (isEligibilityChecked && !isEligible) {
            return 'error';
        }
        return undefined;
    };
    var _w = extractAddressFromFulfillmentGroup(fulfillmentGroup.shippingAndHandling ||
        fulfillmentGroup.storePickup ||
        fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentGroup.fulfillmentType), firstName = _w.firstName, lastName = _w.lastName, addressLine1 = _w.addressLine1, addressLine2 = _w.addressLine2, zipCode = _w.zipCode, city = _w.city, state = _w.state, phoneNumber = _w.phoneNumber;
    useEffect(function () {
        if (!submitCreateForm)
            return;
        // Address has been validated
        // Render Delivery Options when FS is true, not for BOPIS OOS
        if (FeatureSwitches.isSFBLEnabled && !currentBopisOosDrawer) {
            setIsChangeForm(false);
            setIsDeliveryOptions(true);
            setIsLoading(false);
        }
        else if (fulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.BODFS) {
            getAvailableSlots();
        }
        else {
            submitEditDeliveryAddress({
                deliveryAddress: deliveryAddress,
                firstNameValue: firstNameValue,
                lastNameValue: lastNameValue,
                phoneNumberValue: phoneNumberValue,
                isDefaultValue: isDefaultValue,
                orderDetailsData: orderDetailsData,
                fulfillmentTypeCode: fulfillmentTypeCode,
                deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData,
                isAddingNewAddress: isAddingNewAddress,
                fulfillmentGroupIndex: fulfillmentGroupIndex,
                fulfillmentGroup: fulfillmentGroup,
                traceId: traceId,
                setIsChangeForm: setIsChangeForm,
                setIsDeliveryDetails: setIsDeliveryDetails,
                setIsLoading: setIsLoading,
                setShowDrawerError: setShowDrawerError,
                setExcludedShipStateApiError: setExcludedShipStateApiError,
                setIsExcludedAddress: setIsExcludedAddress,
                setIsValidated: setIsValidated,
                closeDrawer: closeDrawer,
                setUpdatedAddressData: setUpdatedAddressData,
                setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
                flowType: flowType,
            });
        }
        // reset submitCreateForm to false
        setSubmitCreateForm(false);
    }, [submitCreateForm]);
    useEffect(function () {
        var _a, _b;
        if (getCitiesByZipCode.length > 0 && isZipCodeChanged) {
            updateFormField({
                cityStateValue: "".concat((_a = getCitiesByZipCode[0]) === null || _a === void 0 ? void 0 : _a.city, ", ").concat((_b = getCitiesByZipCode[0]) === null || _b === void 0 ? void 0 : _b.stateCode),
            });
            setIsZipCodeChanged(false);
        }
    }, [getCitiesByZipCode]);
    useEffect(function () {
        setIsExcludedAddress(false);
    }, [streetAddressValue, zipCodeValue, addressLineTwoValue, cityStateValue]);
    var deliveryAddress = {
        addressLine1: streetAddressValue || '',
        addressLine2: addressLineTwoValue || null,
        city: cityStateValue.split(',')[0],
        state: (_d = cityStateValue === null || cityStateValue === void 0 ? void 0 : cityStateValue.split(',')[1]) === null || _d === void 0 ? void 0 : _d.trim(),
        zipCode: zipCodeValue,
        country: country,
    };
    var getAvailableSlots = function () {
        var _a, _b, _c;
        var availableSlotsRequest = {
            flowType: FLOW_TYPES.EDIT_DELIVERY_ADDRESS,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            originalFulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '',
            newFulfillmentType: null,
            deliverySlotTypes: ['All Day'],
            et: fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.et,
            net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
            lineItems: ((_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _c === void 0 ? void 0 : _c.map(function (type) { return ({
                lineId: type.lineId,
                omsId: "".concat(type.secOmsId),
                sku: "".concat(type.skuNumber),
                price: type.unitPrice,
                quantity: type.currentQuantity,
            }); })) || [],
            fulfillmentAddress: deliveryAddress,
        };
        OmmAvailableDeliverySlots(availableSlotsRequest, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
            .then(function (response) {
            var _a, _b;
            var data = response.data.data;
            setAvailableDeliverySlotsResponse(data);
            var sortedSlots = __spreadArray([], ((_a = data === null || data === void 0 ? void 0 : data.availableDeliverySlots) !== null && _a !== void 0 ? _a : []), true).sort(function (slotA, slotB) {
                return DateTime.fromISO(slotA.startDateTime).toMillis() -
                    DateTime.fromISO(slotB.startDateTime).toMillis();
            });
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
            });
            if (sortedSlots.length > 0) {
                setSelectedDateId(((_b = sortedSlots === null || sortedSlots === void 0 ? void 0 : sortedSlots[0]) === null || _b === void 0 ? void 0 : _b.id) || '');
                setAvailableDeliverySlots(sortedSlots);
                setIsChangeForm(false);
                setIsDeliveryDetails(true);
            }
            else {
                setIsExcludedAddress(true);
            }
        })
            .catch(function () {
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
            });
            closeDrawer();
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var handleClearAll = function () {
        updateFormField({
            firstNameValue: '',
            lastNameValue: '',
            streetAddressValue: '',
            addressLineTwoValue: null,
            zipCodeValue: '',
            cityStateValue: '',
        });
        setCountry(previousCountry);
        setIsSameAddress(false);
        setIsDefault(false);
    };
    var checkSameAddress = function () {
        return areAddressesEqual({
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            city: city,
            state: state,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            zipCode: zipCode,
            country: country,
        }, __assign({ firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue }, deliveryAddress));
    };
    var handleValidateDeliveryAddress = function () {
        validateDeliveryAddress({
            firstNameValue: firstNameValue,
            lastNameValue: lastNameValue,
            phoneNumberValue: phoneNumberValue,
            streetAddressValue: streetAddressValue,
            addressLineTwoValue: addressLineTwoValue,
            zipCodeValue: zipCodeValue,
            cityStateValue: cityStateValue,
            country: country,
            flowType: flowType,
            fulfillmentTypeCode: fulfillmentTypeCode,
            orderDetailsData: orderDetailsData,
            setInvalidField: setInvalidField,
            setIsSameAddress: setIsSameAddress,
            setIsLoading: setIsLoading,
            setNewDeliveryAddressDetails: setNewDeliveryAddressDetails,
            setShowDrawerError: setShowDrawerError,
            fulfillmentGroupIndex: fulfillmentGroupIndex,
            setIsValidated: setIsValidated,
            closeDrawer: closeDrawer,
            setValidationEt: setValidationEt,
            validationEt: validationEt,
            traceId: traceId,
            deliveryAddress: deliveryAddress,
            checkSameAddress: checkSameAddress,
            isPOBoxAddressLine1: isPOBoxAddressLine1,
            isPOBoxAddressLine2: isPOBoxAddressLine2,
            setSubmitCreateForm: setSubmitCreateForm,
            EditDeliveryAddressErrorMessages: EditDeliveryAddressErrorMessages,
            isValidated: isValidated,
            isAddressList: isAddressList,
        });
    };
    var handleChange = function (event) {
        updateFormField({
            cityStateValue: event.target.value,
        });
    };
    var handleZipCodeValueChange = function (zipCodeChange) { return __awaiter(void 0, void 0, void 0, function () {
        var request, availableFulfillmentOptions;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            request = {
                zipCode: zipCodeChange || zipCode,
                orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
                flowType: flowType,
                fulfillmentType: fulfillmentTypeCode,
                originalFulfillmentType: fulfillmentTypeCode,
                newFulfillmentType: null,
            };
            setGetCitiesByZipCode([]);
            availableFulfillmentOptions = {
                flowType: flowType,
                orderId: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) || '',
                emailId: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId) || '',
                originalFulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
                newFulfillmentType: null,
                storeNumber: (_b = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber) === null || _b === void 0 ? void 0 : _b.toString(),
                lineItems: ((_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _c === void 0 ? void 0 : _c.filter(function (type) {
                    return type.lineId !== undefined && type.currentQuantity !== undefined;
                })) === null || _d === void 0 ? void 0 : _d.map(function (type) { return ({
                    lineId: type.lineId,
                    omsId: "".concat(type.secOmsId),
                    sku: "".concat(type.skuNumber),
                    quantity: getQuantityByStatus(type),
                }); })) || [],
                fulfillmentAddress: {
                    zipCode: request.zipCode,
                },
                net: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net) || '',
            };
            if (isZipCodeEligibilityEnabled && isAddressList) {
                setIsSkeletonLoading(true);
                return [2 /*return*/, OmmAvailableFulfillmentOptions(availableFulfillmentOptions, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
                        .then(function (response) {
                        setFulfillmentOptionsResponse(response.data);
                        handleEligibility(response.data, availableFulfillmentOptions, fulfillmentGroup, updateFormField, setIsEligible);
                        setIsEligibilityChecked(true);
                    })
                        .catch(function () {
                        setShowDrawerError(fulfillmentGroupIndex);
                        closeDrawer();
                    })
                        .finally(function () {
                        setIsSkeletonLoading(false);
                    })];
            }
            return [2 /*return*/, SubmitDeliveryAddressGetCitiesByZipCode(request, setGetCitiesByZipCode, setIsChangeForm, setShowDrawerError, fulfillmentGroupIndex, isAuthTHDUser, fulfillmentGroup, orderDetailsData, setIsEligible, updateFormField, setIsEligibilityChecked, setIsSkeletonLoading, availableFulfillmentOptions, setFulfillmentOptionsResponse, closeDrawer)];
        });
    }); };
    useEffect(function () {
        if (!currentBopisOosDrawer &&
            !enteredEditFlow &&
            !isZipCodeEligibilityEnabled) {
            handleZipCodeValueChange();
        }
        setEnteredEditFlow(true);
        if (isAddressList) {
            setIsSkeletonLoading(true);
            // Reset eligibility check state when opening drawer
            setIsEligibilityChecked(false);
            getAddresses({
                orderDetailsData: orderDetailsData,
                fulfillmentTypeCode: fulfillmentTypeCode,
                isAuthTHDUser: isAuthTHDUser,
                fulfillmentGroup: fulfillmentGroup,
                fulfillmentGroupIndex: fulfillmentGroupIndex,
                setDeliveryAddresses: setDeliveryAddresses,
                setDeliveryAddressesApiError: setDeliveryAddressesApiError,
                closeDrawer: closeDrawer,
            })
                .then(function () {
                var initialZipCode = getInitialZipCode(fulfillmentGroup, fulfillmentGroup.fulfillmentType);
                if (isZipCodeEligibilityEnabled && (initialZipCode === null || initialZipCode === void 0 ? void 0 : initialZipCode.length) === 5) {
                    if (zipCodeValue && zipCodeValue !== initialZipCode) {
                        return handleZipCodeValueChange(zipCodeValue);
                    }
                    return handleZipCodeValueChange(initialZipCode);
                }
                return null;
            })
                .finally(function () {
                setIsSkeletonLoading(false);
            });
        }
    }, [isAddressList]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null, isAddressList ? (React.createElement(EditDeliveryAddressChooseAddress, { setCountry: setCountry, handleClearAll: handleClearAll, setIsAddressList: setIsAddressList, setIsDefault: setIsDefault, isExcludedAddress: isExcludedAddress, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress, setLocalCities: setLocalCities, setIsValidated: setIsValidated, setInvalidField: setInvalidField, setIsZipCodeChanged: setIsZipCodeChanged, handleZipCodeValueChange: handleZipCodeValueChange, handleZipCodeStatus: handleZipCodeStatus, invalidField: invalidField, isSkeletonLoading: isSkeletonLoading })) : (React.createElement(EditDeliveryAddressChangeFormBody, { getCitiesByZipCode: getCitiesByZipCode, invalidField: invalidField, isExcludedAddress: isExcludedAddress, isValidated: isValidated, setIsValidated: setIsValidated, isPOBoxAddressLine1: isPOBoxAddressLine1, setIsPOBoxAddressLine1: setIsPOBoxAddressLine1, isPOBoxAddressLine2: isPOBoxAddressLine2, setIsPOBoxAddressLine2: setIsPOBoxAddressLine2, setIsZipCodeChanged: setIsZipCodeChanged, handleZipCodeValueChange: handleZipCodeValueChange, handleChange: handleChange, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress, handleClearAll: handleClearAll, setLocalCities: setLocalCities, localCities: localCities, handleZipCodeStatus: handleZipCodeStatus }))),
        React.createElement(EditDeliveryAddressChangeFormFooter, { isLoading: isLoading, isValidated: isValidated, isIosMobile: isIosMobile, handleValidateDeliveryAddress: handleValidateDeliveryAddress, closeDrawer: closeDrawer, isAddressList: isAddressList, isSkeletonLoading: isSkeletonLoading, invalidField: invalidField })));
};
